module.exports = __webpack_public_path__ + "static/media/aq.7bb48e06.svg";